import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'

Vue.use(Router)

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

function isIgnorableNavigationError(err) {
  const errorName = err && err.name
  if (['NavigationDuplicated', 'NavigationCancelled', 'NavigationRedirected'].includes(errorName)) return true
  return /Navigation (duplicated|cancelled|redirected)|Avoided redundant navigation/.test((err && err.message) || '')
}

function handleNavigationError(err) {
  if (isIgnorableNavigationError(err)) return err
  return Promise.reject(err)
}

Router.prototype.push = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(handleNavigationError)
}

Router.prototype.replace = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(handleNavigationError)
}
function go(to, from, next) {
  store.commit("SET_HEADER_INFO", {
    title: to.meta.headTitle || " ",
    icon: {}
  })
  next()
}

const router = new Router({
  linkActiveClass: 'active',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!(to.meta && to.meta.permission)) return go(to, from, next)
  const Api = (await import('@/api/index')).default
  Api.fetch.jsonRPC({
    url: '/center',
    method: 'get_base_info_permission'
  }).then(res => {
    if (res.success) {
      let userInfo = res.data.user_info
      let module_permissions_list = userInfo.module_permissions_list
      if (
        userInfo.super_admin_status === 1 ||
        (userInfo.admin_status === 1 && !to.meta.disableAdminBypass)
      ) return go(to, from, next)
      // 无任何权限
      if(module_permissions_list.filter(item => Boolean(item)).length == 0) {
        router.push({ name: 'NoPermission' })
        return;
      }
      let permission = module_permissions_list.concat(to.meta.permission)
      let length = Array.from(new Set(permission)).length  // 去重后的权限数组长度
      if (length !== permission.length) return go(to, from, next)
      router.push({ name: 'functionList' })
      console.log('您不具有进入该板块的权限，请联系管理员')
      // vue.openMessage(0, '您不具有进入该板块的权限，请联系管理员')
    } else {
      router.push({ name: 'functionList' })
      console.log('您不具有进入该板块的权限，请联系管理员')
      // vue.openMessage(0, '您不具有进入该板块的权限，请联系管理员')
    }
  }).catch(() => {
    router.push({ name: 'login', query: {redirectUrl: encodeURIComponent(window.location.href)}})
  })
})

export default router
